import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Distributor API authentication is attached centrally so existing screens do not
// need to duplicate security-header code. Authorization remains server-side.
const distributorToken = () => sessionStorage.getItem('distributor_auth_token') || '';

axios.interceptors.request.use((config) => {
  const token = distributorToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers['X-KG-Distributor-Authorization'] = `Bearer ${token}`;
  }
  return config;
});

const nativeFetch = window.fetch.bind(window);
window.fetch = (input, init = {}) => {
  const token = distributorToken();
  if (!token) return nativeFetch(input, init);

  const url = typeof input === 'string' ? input : (input && input.url) || '';
  let isKgApi = false;
  try {
    const resolved = new URL(url, window.location.href);
    const allowedApiOrigins = new Set([
      window.location.origin,
      'https://kgonline.in',
      'https://www.kgonline.in'
    ]);
    isKgApi = allowedApiOrigins.has(resolved.origin) && resolved.pathname.includes('/api/');
  } catch (_) {}

  if (!isKgApi) return nativeFetch(input, init);
  const headers = new Headers(init.headers || (input instanceof Request ? input.headers : undefined));
  headers.set('X-KG-Distributor-Authorization', `Bearer ${token}`);
  return nativeFetch(input, { ...init, headers });
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
